import compileSymbols from '~/utils/compileSymbols';
var types = [
  'ADD_ART',
  'ADD_TO_RECENTLY_USED_ART',
  'BROWSED_CATEGORIES',
  'CATEGORY',
  'CATEGORY_LOADED',
  'CATEGORY_FAILED',
  'CHANGE_SPOT_COLOR',
  'CLEAR',
  'CLIPART_AUTOFILL_DATA_LOADED',
  'LOADING_RESULTS',
  'ROOT',
  'ROOT_LOADED',
  'ROOT_FAILED',
  'SEARCH',
  'SEARCH_LOADED',
  'SEARCH_FAILED',
  'SELECT_CLIPART',
  'SET_RECENTLY_USED_CLIPART',
  'SET_RECENTLY_USED_CLIPART_SNAPSHOT',
  'SET_LAST_SEARCH',
  'SWAP',
  'UPDATE_LOCK_RATIO',
  'UPDATE_ART_SEARCH_HISTORY',
  'UPDATE_TRANSPARENCY',
  'UPDATE_LAST_ART'
];
export default compileSymbols(types, 'art');
